import { CODIGOS_SEGURO_PLANILLA } from '../constants/segurosPlanilla';

const CODIGOS = CODIGOS_SEGURO_PLANILLA.map((item) => item.codigo);

export function filtrarRegistrosSegurosConMonto(registrosSeguros = []) {
  if (!Array.isArray(registrosSeguros)) return [];
  return registrosSeguros.filter((row) => parseFloat(row.monto) > 0);
}

export function construirSeccionSegurosPlanilla(registrosSeguros = [], planillaId = null) {
  const activos = filtrarRegistrosSegurosConMonto(registrosSeguros);

  return {
    tipo: 'seguros_planilla',
    planilla_id: planillaId,
    total_registros: activos.length,
    total_monto: activos.reduce((sum, row) => sum + (parseFloat(row.monto) || 0), 0),
    codigos_activos: [...new Set(activos.map((row) => String(row.codigo_plame)))],
    registros: activos,
    resumen_por_codigo: activos.reduce((acc, row) => {
      const codigo = String(row.codigo_plame);
      if (!acc[codigo]) {
        acc[codigo] = { codigo_plame: codigo, total_monto: 0, empleados: 0 };
      }
      acc[codigo].total_monto += parseFloat(row.monto) || 0;
      acc[codigo].empleados += 1;
      return acc;
    }, {}),
    timestamp: new Date().toISOString(),
    metadatos: {
      origen: 'consideraciones_previas',
      descripcion: 'Seguros de planilla (0803, 0805, 0806, 0810) con monto mayor a cero',
    },
  };
}

export function aplicarSegurosAlArrayUnificado(arrayUnificado, registrosSeguros = [], catalogoPlame = []) {
  const registrosActivos = filtrarRegistrosSegurosConMonto(registrosSeguros);
  if (registrosActivos.length === 0) {
    return arrayUnificado;
  }

  const porEmpleado = registrosActivos.reduce((acc, row) => {
    const empleadoId = Number(row.empleado_id);
    if (!acc[empleadoId]) acc[empleadoId] = [];
    acc[empleadoId].push(row);
    return acc;
  }, {});

  return arrayUnificado.map((elemento) => {
    if (elemento.tipo !== 'empleado_activo_con_apis') {
      return elemento;
    }

    const segurosEmpleado = porEmpleado[Number(elemento.empleado_id)] || [];
    if (segurosEmpleado.length === 0) {
      return elemento;
    }

    const aportesBase = Array.isArray(elemento.conceptosUsuario?.aportes)
      ? elemento.conceptosUsuario.aportes.filter((aporte) => {
          const codigo = String(aporte.codigo_plame || aporte.codigo || '');
          return !CODIGOS.includes(codigo);
        })
      : [];

    const aportesSeguros = segurosEmpleado
      .map((seguro) => {
        const codigo = String(seguro.codigo_plame);
        const monto = parseFloat(seguro.monto);
        if (Number.isNaN(monto) || monto <= 0) return null;

        const configPlame = Array.isArray(catalogoPlame)
          ? catalogoPlame.find((item) => String(item.codigo_plame || item.codigo) === codigo)
          : null;
        const plameId = configPlame?.id || `seguro-${codigo}-${elemento.empleado_id}`;
        const descripcion = configPlame?.descripcion || seguro.descripcion || `Seguro ${codigo}`;

        return {
          id: plameId,
          codigo,
          codigo_plame: codigo,
          codigoPlame: codigo,
          descripcion,
          concepto: descripcion,
          monto,
          plame_configuracion_id: configPlame?.id || null,
          plame_configuracion: configPlame
            ? {
                id: configPlame.id,
                codigo_plame: codigo,
                descripcion,
              }
            : {
                id: plameId,
                codigo_plame: codigo,
                descripcion,
              },
          tipo_concepto: 'aporte',
          origen: 'consideraciones_seguros',
        };
      })
      .filter(Boolean);

    return {
      ...elemento,
      conceptosUsuario: {
        ...elemento.conceptosUsuario,
        aportes: [...aportesBase, ...aportesSeguros],
      },
    };
  });
}
